import PropTypes from 'prop-types';
import { EXCEL_FILE, getFileTypeCategory } from '../../../../../helpers/fileTransferHelper';
import Dropzone from 'react-dropzone';
import React from 'react';
import { getAcceptedFileTypes } from 'shared/helpers/fileHelper';


class TTDropZone extends React.Component {
  constructor(props) {
    super(props);
    this.accept = getAcceptedFileTypes(['excel']);
  }

  render() {
    const { children, onDropAccepted, disabled } = this.props;
    return (
      <Dropzone
        ref={ (node) => { this.dropzone = node; } }
        style={ { border: 'none', width: 652 } }
        multiple={ false }
        onDrop={ (files) => {
          const fileNameSplitted = files[0].name.split('.');
          const fileExtension  = fileNameSplitted[fileNameSplitted.length - 1];
          if(getFileTypeCategory(fileExtension) === EXCEL_FILE) {
            onDropAccepted(files);
          }
        } }
        accept={ this.accept }
        disabled={ disabled }
      >
        { children }
      </Dropzone>
    );
  }
}

TTDropZone.propTypes = {
  children: PropTypes.node.isRequired,
  onDropAccepted: PropTypes.func.isRequired,
  disabled: PropTypes.bool
};

TTDropZone.defaultValue = {
  disabled: false
};

export default TTDropZone;



// WEBPACK FOOTER //
// ./src/shared/components/translationTable/c/ttRowsOptions/ttDropZone/TTDropZone.js